import React, { useState } from "react";
import { Button } from "@blueprintjs/core";

export default function DialogButton({ dialog: Dialog, children, onClose, ...others }) {
  const [show, setShow] = useState(false);
  return (
    <>
      {show && (
        <Dialog
          {...others}
          onClose={() => {
            setShow(false);
            if (onClose) {
              onClose();
            }
          }}
        />
      )}
      <Button loading={show} onClick={() => setShow(true)}>
        {children}
      </Button>
    </>
  );
}

// dialog({
//   ...others,
//   onClose: () => {
//     setShow(false);
//     if (onClose) {
//       onClose();
//     }
//   },
// })
